export default "__VITE_ASSET__Ds4PrDDh__"